import { render, staticRenderFns } from "./Notifs.vue?vue&type=template&id=1823afe6"
import script from "./Notifs.vue?vue&type=script&lang=js"
export * from "./Notifs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports